let config: Record<string, string | number> = {};

const prefix = 'VITE_';

for (const [key, value] of Object.entries(import.meta.env)) {
  if (!key.startsWith(prefix)) {
    continue;
  }
  const confKey = key.replace(prefix, '');
  config[confKey] = value as string | number;
}

config = {
  ...config,
  APP_VERSION: '1.19.2',
  APP_TITLE: 'Maverick Signings',
  // refresh cookie is available in paths prefixed with this value
  // must match backend value
  AUTH_PATH_PREFIX: '/auth',
  // api urls
  API_BE_URL: config.API_URL + '/be',
};

export default config;
